import { render, staticRenderFns } from "./CustomersEventsUsed.vue?vue&type=template&id=466aa98b&scoped=true"
import script from "./CustomersEventsUsed.vue?vue&type=script&lang=js"
export * from "./CustomersEventsUsed.vue?vue&type=script&lang=js"
import style0 from "./CustomersEventsUsed.vue?vue&type=style&index=0&id=466aa98b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466aa98b",
  null
  
)

export default component.exports